(function () {
  var RECENTLY_VIEWED_KEY = 'bb_recently_viewed_products';
  var RECOMMENDATION_STATE_KEY = 'bb_cart_recommendations_v16';
  var refreshTokens = new WeakMap();
  var sectionStates = new WeakMap();
  var refreshTimer = null;

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function safeJson(url) {
    return window.fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).catch(function () {
      return null;
    });
  }

  function asProducts(payload) {
    if (!payload) return [];
    if (Array.isArray(payload.products)) return payload.products;
    if (payload.product) return [payload.product];
    if (payload.id && payload.handle) return [payload];
    return [];
  }

  function imageUrl(product) {
    var image = product.featured_image || (product.images && product.images[0]);
    if (image && typeof image === 'object') image = image.src || image.url;
    if (!image) return '';
    if (image.indexOf('//') === 0) return 'https:' + image;
    return image;
  }

  function availableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false) return variants[i];
    }
    return null;
  }

  function productPrice(product, variant) {
    if (typeof product.price === 'number' && Number.isFinite(product.price)) return Math.round(product.price);

    var price = variant && variant.price != null ? variant.price : product.price;
    if (typeof price === 'string') {
      var decimalPrice = Number(price.replace(',', '.'));
      return Number.isFinite(decimalPrice) ? Math.round(decimalPrice * 100) : 0;
    }

    return Number.isFinite(Number(price)) ? Math.round(Number(price)) : 0;
  }

  function productIsEligible(product, cartIds, cartHandles) {
    if (!product || !product.id || !product.handle) return false;
    if (cartIds.has(String(product.id)) || cartHandles.has(product.handle)) return false;
    if (product.available === false || !availableVariant(product)) return false;
    return productPrice(product, availableVariant(product)) > 0;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    if (currency === 'EUR') return '€' + (cents / 100).toFixed(2);

    try {
      return new Intl.NumberFormat('en-IE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function productLink(product) {
    return rootPath() + 'products/' + encodeURIComponent(product.handle);
  }

  function card(product, source) {
    var variant = availableVariant(product);
    var image = imageUrl(product);
    var label = source === 'recent' ? 'Recently viewed' : source === 'new' ? 'New arrival' : source === 'popular' ? 'Popular' : 'Recommended';
    var imageMarkup = image
      ? '<img class="bb-smart-recommendations__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="500" height="500">'
      : '<span class="visually-hidden">Product image unavailable</span>';

    return [
      '<li class="bb-smart-recommendations__card" data-bb-recommendation-id="' + escapeHtml(product.id) + '">',
        '<a class="bb-smart-recommendations__media" href="' + escapeHtml(productLink(product)) + '">', imageMarkup, '</a>',
        '<div class="bb-smart-recommendations__content">',
          '<span class="bb-smart-recommendations__badge">', escapeHtml(label), '</span>',
          '<a class="bb-smart-recommendations__title" href="' + escapeHtml(productLink(product)) + '">', escapeHtml(product.title), '</a>',
          '<div class="bb-smart-recommendations__price">', escapeHtml(money(productPrice(product, variant))), '</div>',
          '<form method="post" action="' + escapeHtml(rootPath() + 'cart/add') + '">',
            '<input type="hidden" name="id" value="' + escapeHtml(variant.id) + '">',
            '<input type="hidden" name="quantity" value="1">',
            '<input type="hidden" name="return_to" value="' + escapeHtml(rootPath() + 'cart') + '">',
            '<button class="bb-smart-recommendations__add" type="submit">Add to basket</button>',
          '</form>',
        '</div>',
      '</li>'
    ].join('');
  }

  function recentlyViewedHandles(cartHandles) {
    try {
      var saved = JSON.parse(window.localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(function (handle) {
        return typeof handle === 'string' && !cartHandles.has(handle);
      }).slice(0, 8);
    } catch (error) {
      return [];
    }
  }

  function readSavedSelection() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(RECOMMENDATION_STATE_KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(function (item) {
        return item && item.product && item.product.id && item.product.handle;
      }).slice(0, 5);
    } catch (error) {
      return [];
    }
  }

  function saveSelection(selected) {
    try {
      window.sessionStorage.setItem(RECOMMENDATION_STATE_KEY, JSON.stringify(selected.slice(0, 5)));
    } catch (error) {
      // Recommendations still work when storage is unavailable or full.
    }
  }

  function take(selected, seen, products, source, count, eligible) {
    var added = 0;
    for (var i = 0; i < products.length && added < count; i += 1) {
      var product = products[i];
      if (!eligible(product) || seen.has(String(product.id))) continue;
      seen.add(String(product.id));
      selected.push({ product: product, source: source });
      added += 1;
    }
  }

  function embeddedCart(section) {
    var cartData = section.querySelector('[data-bb-cart-products]');
    if (!cartData) return [];

    try {
      var cart = JSON.parse(cartData.textContent || '[]');
      return Array.isArray(cart) ? cart : [];
    } catch (error) {
      return [];
    }
  }

  function cartFromPayload(payload) {
    var items = payload && Array.isArray(payload.items) ? payload.items : [];

    return items.map(function (item) {
      var handle = item.handle || '';
      if (!handle && item.url) {
        var match = String(item.url).match(/\/products\/([^/?#]+)/);
        if (match) {
          try { handle = decodeURIComponent(match[1]); } catch (error) { handle = match[1]; }
        }
      }

      return { id: item.product_id || item.productId || item.id, handle: handle };
    }).filter(function (item) { return item.id; });
  }

  function cartKey(cart) {
    return cart.map(function (item) {
      return String(item.id) + ':' + item.handle;
    }).sort().join('|');
  }

  function animateCards(cards) {
    if (!cards.length) return;
    window.requestAnimationFrame(function () {
      cards.forEach(function (cardElement) {
        cardElement.classList.add('is-visible');
      });
    });
  }

  function updateGrid(section, selected) {
    var grid = section.querySelector('[data-bb-recommendation-grid]');
    var existing = new Map();
    var newCards = [];

    grid.querySelectorAll('[data-bb-recommendation-id]').forEach(function (element) {
      existing.set(element.getAttribute('data-bb-recommendation-id'), element);
    });

    var selectedIds = new Set(selected.map(function (item) { return String(item.product.id); }));
    existing.forEach(function (element, id) {
      if (!selectedIds.has(id)) element.remove();
    });

    selected.forEach(function (item) {
      var id = String(item.product.id);
      var element = existing.get(id);
      if (!element || !element.isConnected) {
        var template = document.createElement('template');
        template.innerHTML = card(item.product, item.source).trim();
        element = template.content.firstElementChild;
        element.classList.add('is-entering');
        newCards.push(element);
      }
      grid.appendChild(element);
    });

    section.hidden = selected.length === 0;
    animateCards(newCards);
  }

  function placeAdditionsInOpenSlots(slots, selected, previousIds, max) {
    var additions = selected.filter(function (item) {
      return !previousIds.has(String(item.product.id));
    });
    var additionIndex = 0;
    var merged = slots.map(function (item) {
      if (item) return item;
      var replacement = additions[additionIndex];
      additionIndex += 1;
      return replacement || null;
    }).filter(Boolean);

    while (merged.length < max && additionIndex < additions.length) {
      merged.push(additions[additionIndex]);
      additionIndex += 1;
    }

    return merged.slice(0, max);
  }

  function render(section, cart) {
    var status = section.querySelector('[data-bb-recommendation-status]');
    var max = Math.min(5, Math.max(3, Number(section.getAttribute('data-max-products')) || 5));
    var state = sectionStates.get(section) || { cart: [], cartKey: null, selected: [] };
    var nextCartKey = cartKey(cart);

    if (state.cartKey === nextCartKey && state.selected.length) {
      status.textContent = state.selected.length + ' product recommendations available.';
      return;
    }

    var previousCart = state.cart;
    var token = (refreshTokens.get(section) || 0) + 1;
    refreshTokens.set(section, token);

    if (!cart.length) {
      state.cart = [];
      state.cartKey = nextCartKey;
      state.selected = [];
      sectionStates.set(section, state);
      updateGrid(section, []);
      saveSelection([]);
      status.textContent = 'No product recommendations available.';
      return;
    }

    var cartIds = new Set(cart.map(function (item) { return String(item.id); }));
    var cartHandles = new Set(cart.map(function (item) { return item.handle; }));
    var eligible = function (product) { return productIsEligible(product, cartIds, cartHandles); };
    var previousSelection = (state.selected.length ? state.selected : readSavedSelection()).slice(0, max);
    var selectedSlots = previousSelection.map(function (item) {
      return eligible(item.product) ? item : null;
    });
    var previousSelected = selectedSlots.filter(Boolean);
    var gridHasCards = section.querySelector('[data-bb-recommendation-grid]').children.length > 0;

    // Keep the current row in place while a replacement is fetched. Removing an
    // added card early would make every following card jump into a new position.
    if (previousSelected.length && (!gridHasCards || previousSelected.length === previousSelection.length)) {
      updateGrid(section, previousSelected.slice(0, max));
    }
    status.textContent = previousSelected.length ? 'Updating product recommendations.' : 'Loading product recommendations.';

    var departedHandles = previousCart.map(function (item) { return item.handle; }).filter(function (handle) {
      return handle && !cartHandles.has(handle);
    });
    var root = rootPath();
    var relatedUrl = root + 'recommendations/products.json?product_id=' + encodeURIComponent(cart[0].id) + '&limit=10&intent=related';
    var recentHandles = recentlyViewedHandles(cartHandles);
    var productRequests = recentHandles.concat(departedHandles).filter(function (handle, index, handles) {
      return handles.indexOf(handle) === index;
    }).map(function (handle) {
      return safeJson(root + 'products/' + encodeURIComponent(handle) + '.js');
    });

    Promise.all([
      safeJson(relatedUrl),
      Promise.all(productRequests),
      safeJson(root + 'collections/all/products.json?sort_by=best-selling&limit=20'),
      safeJson(root + 'collections/all/products.json?sort_by=created-descending&limit=10')
    ]).then(function (results) {
      if (refreshTokens.get(section) !== token) return;

      var relatedProducts = asProducts(results[0]);
      var requestedProducts = results[1].reduce(function (all, payload) { return all.concat(asProducts(payload)); }, []);
      var departedProducts = requestedProducts.filter(function (product) { return departedHandles.indexOf(product.handle) !== -1; });
      var recentProducts = requestedProducts.filter(function (product) { return recentHandles.indexOf(product.handle) !== -1; });
      var popularProducts = asProducts(results[2]);
      var newProducts = asProducts(results[3]);
      var selected = previousSelected.slice(0, max);
      var seen = new Set(selected.map(function (item) { return String(item.product.id); }));
      var previousIds = new Set(previousSelected.map(function (item) { return String(item.product.id); }));

      // A removed cart product becomes eligible immediately. Replace only the final
      // recommendation when the row is full so the rest of the set stays stable.
      var eligibleDeparted = departedProducts.filter(function (product) {
        return eligible(product) && !seen.has(String(product.id));
      });
      if (eligibleDeparted.length && selected.length >= max) {
        var removed = selected.pop();
        seen.delete(String(removed.product.id));
        previousIds.delete(String(removed.product.id));
        selectedSlots[selectedSlots.length - 1] = null;
      }
      take(selected, seen, eligibleDeparted, 'related', max - selected.length, eligible);
      take(selected, seen, relatedProducts, 'related', Math.min(2, max - selected.length), eligible);
      take(selected, seen, recentProducts, 'recent', Math.min(1, max - selected.length), eligible);
      take(selected, seen, newProducts, 'new', Math.min(1, max - selected.length), eligible);
      take(selected, seen, popularProducts, 'popular', max - selected.length, eligible);
      take(selected, seen, relatedProducts, 'related', max - selected.length, eligible);
      take(selected, seen, recentProducts, 'recent', max - selected.length, eligible);

      selected = placeAdditionsInOpenSlots(selectedSlots, selected, previousIds, max);

      state.cart = cart;
      state.cartKey = nextCartKey;
      state.selected = selected.slice(0, max);
      sectionStates.set(section, state);
      updateGrid(section, state.selected);
      saveSelection(state.selected);
      status.textContent = state.selected.length
        ? state.selected.length + ' product recommendations loaded.'
        : 'No product recommendations available.';
    });
  }

  function refreshAll() {
    safeJson(rootPath() + 'cart.js').then(function (payload) {
      var cart = cartFromPayload(payload);
      document.querySelectorAll('[data-bb-smart-recommendations]').forEach(function (section) {
        render(section, cart);
      });
    });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshAll, 80);
  }

  function addRecommendationToCart(event) {
    var form = event.target.closest('[data-bb-smart-recommendations] form');
    if (!form) return;

    event.preventDefault();

    var section = form.closest('[data-bb-smart-recommendations]');
    var status = section && section.querySelector('[data-bb-recommendation-status]');
    var button = form.querySelector('.bb-smart-recommendations__add');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    var originalText = button.textContent;
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var cartNotification = document.querySelector('cart-notification');

    formData.delete('return_to');
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    button.setAttribute('aria-disabled', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = 'Adding product to basket.';

    window.fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add this product.');
        }
        return payload;
      });
    }).then(function (addResponse) {
      if (cartNotification && typeof cartNotification.renderContents === 'function') {
        cartNotification.renderContents(addResponse);
      }

      return safeJson(rootPath() + 'cart.js').then(function (cartPayload) {
        if (!cartPayload) throw new Error('Unable to refresh the basket.');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          return Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bb-smart-recommendations',
            productVariantId: variantId,
            cartData: cartPayload
          }));
        }

        refreshAll();
        return null;
      });
    }).catch(function (error) {
      if (status) status.textContent = error.message || 'Unable to add this product to the basket.';
      if (button.isConnected) {
        button.removeAttribute('aria-disabled');
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  }

  function start() {
    document.querySelectorAll('[data-bb-smart-recommendations]').forEach(function (section) {
      section.addEventListener('submit', addRecommendationToCart);
      render(section, embeddedCart(section));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
